import React,{useState,useEffect} from 'react';
import {LoaderContext} from '../../../../../../context/LoaderContext'
import {SnackBarContext} from '../../../../../../context/SnackBarContext'
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import {http_request} from '../../../../../../utils/http_request'
import {endpoint} from '../../../../../../config'
import {mobile_validation} from '../../../../../../utils/validations'
import {Redirect} from 'react-router-dom'
import Button from '@material-ui/core/Button';
export default(props)=>{
  const loader=React.useContext(LoaderContext);
  const snackBar=React.useContext(SnackBarContext);

  return(
 <Comp {...props} loader={loader} snackBar={snackBar}/>
  )
}


const Comp=({snackBar,loader,classes})=>{
    const [roll_no, setRollNo] = useState('');
    const [mobile, setMobile] = useState('');
const [login,setLogin]=useState(false)


    useEffect(() => {
      ValidatorForm.addValidationRule('isValidRollNo', (value) => {
        if(value.length!==8 || isNaN(value))
        return false;
        return true;
      });

      ValidatorForm.addValidationRule('isValidMobile', (value) => {
        return mobile_validation(value)
      });

    return () => {
      ValidatorForm.removeValidationRule('isValidRollNo');
        ValidatorForm.removeValidationRule('isValidMobile');
        };
         },[]
      );

    async function handleSubmit(){

      try{
    loader.show()
          const {data}=  await http_request({endpoint:endpoint,service:'aptitude-test-login',variables:`roll_no=${roll_no}&mobile=${mobile}`})

       if(data.success){

          localStorage.setItem("aptitude_test_token",data.token)
          setLogin(true)
       }
            }
            catch(e){
       snackBar.show(e.message)
            }
            finally{
          loader.hide()
         }


    }
  return(
    <div className={classes.form}>
    <ValidatorForm
        onSubmit={handleSubmit}
    >
        <TextValidator
autoComplete={"off"}
      margin="normal"
    variant="outlined"
      fullWidth
      autoFocus
            label="Aptitude Test Roll No."
            onChange={(e)=>setRollNo(e.target.value)}
            name="mobile"
            type="tel"
            validators={['required','isValidRollNo' ]}
            errorMessages={['Aptitude Test Roll No. is required','Aptitude Test Roll No. must contain 8 digits'  ]}
            value={roll_no}
        />
 <br />
 <TextValidator
autoComplete={"off"}
margin="normal"
variant="outlined"
fullWidth

     label="Mobile No."
     onChange={(e)=>setMobile(e.target.value)}
     name="mobile"
     type="tel"
     validators={['required','isValidMobile']}
     errorMessages={['mobile number is required','please enter correct mobile number']}

       value={mobile}
 />
 <br />

        <Button  type="submit"
    fullWidth
    variant="contained"
    color="primary"

     >
      Log in
     </Button>
    </ValidatorForm>
    {login && <Redirect to="/aptitude-test-result/dashboard"/>}
    </div>
  )
}
